import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import TierSidebarCard from '../../../../DeviationViews/TierSidebarCard';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { getTierListCardBI } from '../../../helpers';
import SubscriptionLockFTUE from '../../../../Tier/ftue/SubscriptionLockFTUE';
import { useSubscriptionLockSidebarFTUE } from '../../../../Tier/ftue/useSubscriptionLockFTUE';
import s from './TierList.scss';
const TierList = ({ block, deviation: parentDeviation })=>{
    var _block_deviations_map, _this;
    const { isShowingSubscriptionsFTUE, dropFlag } = useSubscriptionLockSidebarFTUE(block.contentType, parentDeviation);
    var _block_deviations;
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        className: s[block.contentType],
        headerClassName: s['header'],
        titleClassName: s['title'],
        seeAllClassName: s['link']
    }, /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: `sidebar-tiers-${block.contentType}`,
        deviations: (_block_deviations = block.deviations) !== null && _block_deviations !== void 0 ? _block_deviations : [],
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        }
    }, (_this = block.deviations) === null || _this === void 0 ? void 0 : (_block_deviations_map = _this.map) === null || _block_deviations_map === void 0 ? void 0 : _block_deviations_map.call(_this, (tier, i)=>isShowingSubscriptionsFTUE && i === 0 ? /*#__PURE__*/ React.createElement(SubscriptionLockFTUE, {
            dropFlag: dropFlag,
            className: s['ftue'],
            key: tier.deviationId,
            deviation: tier
        }) : /*#__PURE__*/ React.createElement(TierSidebarCard, {
            key: tier.deviationId,
            biData: getTierListCardBI(block.contentType, tier),
            className: s['tier'],
            deviation: tier
        }))));
};
TierList.displayName = 'TierList';
export default TierList;
